"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BookIcon = exports.PublicationIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("../helpers");

var _Icon = require("./Icon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/** PublicationIcon */
var PublicationIcon = function PublicationIcon(props) {
  return _react.default.createElement(_Icon.Icon, _extends({}, props, {
    viewBox: "0 0 18 18"
  }), _react.default.createElement(_Icon.Title, null, "publication"), _react.default.createElement(_Icon.Path, {
    d: "M9.455 6.98v6.887L14 12.749V5.232l-4.5.946-.045.802zM9 15l-6-1.467V4l6 1.262L15 4v9.533L9 15zm-.345-.324l-.057.233v-.287l.057.054zm-.2-.832V6.17L4 5.232v7.517l4.455 1.095zm.947.065v1l-.238-.971.117-.029h.121z",
    fill: (0, _helpers.color)(props.fill),
    fillRule: "nonzero"
  }));
};

exports.PublicationIcon = PublicationIcon;
PublicationIcon.displayName = "PublicationIcon";
// TODO: remove this alias once clients have been updated

/** BookIcon */
var BookIcon = PublicationIcon;
exports.BookIcon = BookIcon;
//# sourceMappingURL=PublicationIcon.js.map